export default [
  {
    key: 'id',
    type: 'id',
    visibility: ['view'],
  },
  {
    key: 'name',
    label: 'Brand',
    type: 'profile',
    image: 'image_url',
  },
  {
    key: 'user.email',
    label: 'Email',
    type: 'email',
  },
  {
    key: 'user.phone',
    label: 'Nomor HP',
    type: 'whatsapp',
    prefix: '+',
  },
  {
    key: 'is_active',
    label: 'Status',
    filter: {
      key: 'is_active',
      type: 'select',
      label: 'Status',
      options: [
        { value: true, text: 'Aktif' },
        { value: false, text: 'Tidak aktif' },
      ],
    },
  },
  {
    key: 'is_open',
    label: 'Toko',
    type: 'badge',
    visibility: ['view'],
    map: {
      buka: 'success',
      tutup: 'danger',
    },
    filter: {
      key: 'is_open',
      type: 'select',
      label: 'Toko',
      options: [
        { value: true, text: 'Buka' },
        { value: false, text: 'Tutup' },
      ],
    },
  },
  {
    key: 'affiliate_percentage',
    label: 'Aff %',
    suffix: ' %',
    type: 'number',
    visibility: ['view'],
    filter: {
      type: 'number_range',
      gteKey: 'affiliate_percentage_gte',
      ltKey: 'affiliate_percentage_lt',
      placeholderGte: 'Min %',
      placeholderLt: 'Max %',
    },
  },
  {
    key: 'brand_score',
    label: 'Skor',
    type: 'number',
    visibility: ['view'],
    filter: {
      type: 'number_range',
      gteKey: 'brand_score_gte',
      ltKey: 'brand_score_lt',
      placeholderGte: 'Min',
      placeholderLt: 'Max',
    },
  },
  {
    key: 'created_at',
    label: 'Dibuat',
    type: 'datetime',
    filter: {
      type: 'datetime',
      startKey: 'created_at_gte',
      endKey: 'created_at_lt',
    },
  },
  {
    key: 'description',
    label: 'Deskripsi',
    type: 'html',
    visibility: ['view'],
  },
  {
    key: 'courier_names',
    label: 'Kurir',
    type: 'badges',
    visibility: ['view'],
  },
  {
    key: 'address.province_name',
    label: 'Provinsi',
    visibility: ['view'],
  },
  {
    key: 'address.city_name',
    label: 'Kota/Kab.',
    visibility: ['view'],
  },
]
